import React, { useEffect, useState } from 'react';
import Table, { CurrencyCell, MultiSelectFilter, includesOr } from './controls/Table';

function GroceryHistoryByItem() {
  const [data, setData] = useState([]);

  useEffect(() => {
    getData();
  }, []);


  const getData = async () => {
    try {
      const response = await fetch('api/groceries/getgroceryhistorybyitem');
      const data = await response.json();
      setData(data);
    } catch (error) {
      console.error(error);
    }
  };

  const itemSummaryColumns = React.useMemo(
    () => [
      {
        Header: 'ItemId',
        accessor: 'itemId',
        Footer: '',
      },
      {
        Header: 'UPC',
        accessor: 'upc',
        Footer: '',
      },
      {
        Header: 'Brand',
        accessor: 'brand',
        Filter: MultiSelectFilter,
        filter: includesOr,
        Footer: '',
      },
      {
        Header: 'Description',
        accessor: 'description',
        Footer: '',
      },
      {
        Header: 'Size',
        accessor: 'size',
        Footer: '',
      },
      {
        Header: 'TotalQuantity',
        accessor: 'totalQuantity',
        Footer: '',
      },
      {
        Header: 'TotalPaid',
        accessor: 'totalPaid',
        Cell: CurrencyCell,
        Footer: info => {
          const total = info.rows.reduce((sum, row) => row.values.totalPaid + sum, 0);
          return <><b>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(total)}</b></>;
        },
      },
      {
        Header: 'AveragePrice',
        accessor: row => row.totalQuantity > 0 ? (row.totalPaid / row.totalQuantity).toFixed(2) : 'N/A',
        Footer: '',
      },
    ],
    []
  );

  const itemColumns = React.useMemo(
    () => [
      {
        Header: 'TransactionTime',
        accessor: 'transactionTime',
        Footer: '',
      },
      {
        Header: 'Quantity',
        accessor: 'quantity',
        Footer: '',
      },
      {
        Header: 'UnitPrice',
        accessor: 'unitPrice',
        Cell: CurrencyCell,
        Footer: '',
      },
      {
        Header: 'TotalSavings',
        accessor: 'totalSavings',
        Cell: CurrencyCell,
        Footer: info => {
          const total = info.rows.reduce((sum, row) => row.values.totalSavings + sum, 0);
          return <><b>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(total)}</b></>;
        },
      },
      {
        Header: 'UnitPricePaid',
        accessor: 'unitPricePaid',
        Cell: CurrencyCell,
        Footer: '',
      },
      {
        Header: 'TotalPaid',
        accessor: 'totalPaid',
        Cell: CurrencyCell,
        Footer: info => {
          const total = info.rows.reduce((sum, row) => row.values.totalPaid + sum, 0);
          return <><b>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(total)}</b></>;
        },
      },
    ],
    []
  );

  const getNestedData = (row) => {
    return row.original.purchases || [];
  };

  return (
    <div>
      <div>
        <h4>Grocery Items ({data.length})</h4>
        <Table
          columns={itemSummaryColumns}
          data={data}
          nestedColumns={itemColumns}
          getNestedData={getNestedData}>
        </Table>
      </div>
    </div>
  );
}

export default GroceryHistoryByItem;